import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { LoadingOrValue } from "../../loading";

interface DisplayPropertiesCardArrayProps {
  sectionLabel: string;
  value:
    | {
        itemLabel?: string | null;
        itemValue?: number | string | null;
        itemPrefix?: string;
      }[]
    | string;
  loading?: boolean;
}

export function DisplayPropertiesCardArray({
  sectionLabel,
  value,
  loading,
}: DisplayPropertiesCardArrayProps) {
  return (
    <Box
      border="1px solid"
      borderRadius="10px"
      padding={3}
      borderColor="action.disabled">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography color="textPrimary">{sectionLabel}</Typography>
        </Grid>
        {typeof value === "string" ? (
          <Grid item xs={4}>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{ fontWeight: 300 }}>
              <LoadingOrValue
                loading={!!loading}
                value={value}
                height={24}
                width={200}
              />
            </Typography>
          </Grid>
        ) : (
          value.map(({ itemLabel, itemValue, itemPrefix }) => {
            return (
              <Grid item xs={4} key={itemLabel}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  sx={{ fontWeight: 300 }}>
                  {itemLabel}
                </Typography>

                <Typography>{`${itemPrefix || ""}${itemValue}`}</Typography>
              </Grid>
            );
          })
        )}
      </Grid>
    </Box>
  );
}
